import { atom } from 'jotai'
import { TAddressHistory } from '../types/address-history.type'

export const addressHistoryState = atom<TAddressHistory>({
    login_id: '',
    ushopCountryCode: '',
    log_id: null,
    duration: '',
    mainAddress: {
        shipToAddress: {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: ''
        },
        shipToName: {
            firstName: '',
            lastName: '',
            fullName: '',
            'fullName@en': ''
        },
        ushopShipToName: '',
        displayAddress: '',
        displayType: ''
    },
    totalItems: 0,
    items: [],
    invalidAddresses: []
})
